__turbopack_context__.v({
  "close": "WtSurvey-module-scss-module__ntvKfG__close",
  "content": "WtSurvey-module-scss-module__ntvKfG__content",
  "cta": "WtSurvey-module-scss-module__ntvKfG__cta",
  "headline": "WtSurvey-module-scss-module__ntvKfG__headline",
  "illustration": "WtSurvey-module-scss-module__ntvKfG__illustration",
  "illustrationImage": "WtSurvey-module-scss-module__ntvKfG__illustrationImage",
  "modal": "WtSurvey-module-scss-module__ntvKfG__modal",
  "subtitle": "WtSurvey-module-scss-module__ntvKfG__subtitle",
});
